import { Component, OnInit, AfterViewInit,ViewChild,ViewEncapsulation } from '@angular/core';
import { Chart } from 'chart.js';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { StockService } from '../../services/stock.service';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Stock } from '../../model/Stock';
import { LoadService } from '../../services/load.service';
import { ClientsService } from '../../services/clients.service';
import { LocationService } from '../../services/location.service';

@Component({
  selector: 'panelcontrol',
  templateUrl: './panelcontrol.component.html',
  styleUrls: ['./panelcontrol.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PanelcontrolComponent implements OnInit {
  public isopen:boolean;
  public alert:string;
  public load:number;
  public loaded:boolean;
  public chart = [];
  public canvas: any;
  public ctx: any;
  public ubicaciones: any[];
  public cantidadtotalcajas : number;
  public cantidadtotalpeso : number;
  public tabla : any[];
  public primeracarga : boolean;
  public cantidadtotalpallets :number;
  public formula : any[];
  public loading:boolean;
  public textloading:string;

  constructor(private _stockService:StockService,private _loaddata: LoadService,private _clientes: ClientsService,private _location: LocationService) {
    this.loaded = false;
    this.ubicaciones = [];
    this.tabla = [];
    this.primeracarga = false;
    this.loading = true;
    this.textloading = 'Cargando Información';
  }

  ngOnInit() {
    this.loaded = true;
    this._loaddata.loadChange(0);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this._loaddata.loadChange(0);
    this.cantidadtotalpeso = 0;
    this.cantidadtotalcajas = 0;
    this.cantidadtotalpallets = 0;
    this.ubicaciones = [];
    this.primeracarga = false;
    this.isopen = true;
    this.loadInOutFormula();
  }

  loadInOutFormula(){
    this.alert = 'Cargando información.';
    this._loaddata.loadChange(0);
    this.isopen = true;

    this.formula = [];
    this._stockService.getStockFormulaCS().subscribe(
      (response:any) => {
        this.alert = 'Calculando Stock.';
        this._loaddata.loadChange(0);
        let stockcalculado = (Number(response.success.initial) +(Number(response.success.inputs) - Number(response.success.outputs)));
        this.formula.push({'initial':Number(response.success.initial).toFixed(2),'inputs':Number(response.success.inputs).toFixed(2),'outputs':Number(response.success.outputs).toFixed(2),'stockcalculado':stockcalculado.toFixed(2),'stock':Number(response.success.stock).toFixed(2),'diferencia':Math.abs(Number(response.success.stock) - (stockcalculado)).toFixed(2)});
        this.prepareData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  prepareData(){
    this.isopen = true;
    this.textloading = 'Construyendo Gráficos';
    this.alert = 'Construyendo graficos.';
    this._loaddata.loadChange(0);
    let labels = [];
    let cajas = [];
    let completas = [];
    let saldos = [];
    let pallets = [];
    let total = [];
    let totalcajas = [];
    let totalsaldos = [];
    let pos = 0;

    this._stockService.getStockDataGraph().subscribe(
      (response:any) => {
        this.alert = 'Dibujando graficos.';
        this._loaddata.loadChange(0);
        for(let data of response.data){
          if(data.location ==  null){
            labels.push('Sin ubicación');
          }
          else{
            labels.push(data.location);
          }
          cajas.push(Number(data.total_boxes));
          completas.push(Number(data.normal_box));
          saldos.push(Number(data.residue_box));
          pallets.push(Number(data.pallet));
          total.push(Number(data.total));
          totalcajas.push(Number(data.total_normal_box));
          totalsaldos.push(Number(data.total_residue));
          this.cantidadtotalpeso += Number(data.total);
          this.cantidadtotalcajas += Number(data.total_boxes);
          this.cantidadtotalpallets += Number(data.pallet);

          this.tabla.push({'ubicacion':data.location,'cajas':Number(data.total_boxes),'peso':Number(data.total),'pallet':Number(data.pallet)});
          pos +=1;
        }

        this.drawGraphPalletsUbicacion(labels,pallets)
        this.drawGraphCajasUbicacion(labels,cajas);
        this.drawGraphCajasCompletasUbicacion(labels,completas);
        this.drawGraphSaldosUbicacion(labels,saldos);
        this.drawGraphPesosUbicacion(labels,total);
        this.drawGraphPesosCompletosUbicacion(labels,totalcajas);
        this.drawGraphPesosSaldosUbicacion(labels,totalsaldos);

        if(this.primeracarga == false){
          this.primeracarga = true;
        }
        this.loading = false;
        this.alert = 'Carga finalizada.';
        this._loaddata.loadChange(0);
        this.onClosedAutomatic();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  drawGraphCajasUbicacion(labels,cajas){
    this.canvas = document.getElementById('graficocajasxubicacion');
    this.ctx = this.canvas.getContext('2d');

    const chart: Chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Cajas',
            data: cajas,
            backgroundColor: 'rgba(52, 152, 219, 0.7)'
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: 'TOTAL CAJAS POR UBICACIÓN',
          position: 'top',
          fontSize: 18,
          fontColor: '#3498DB',
          padding:25
        }
      }
    });
  }

  drawGraphCajasCompletasUbicacion(labels,cajas){
    this.canvas = document.getElementById('graficocompletasxubicacion');
    this.ctx = this.canvas.getContext('2d');

    const chart: Chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Cajas Completas',
            data: cajas,
            backgroundColor: 'rgba(52, 152, 219, 0.7)'
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: 'CAJAS COMPLETAS POR UBICACIÓN',
          position: 'top',
          fontSize: 18,
          fontColor: '#3498DB',
          padding:25
        }
      }
    });

    /*const chart: Chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Cajas Completas',
            data: cajas,
            backgroundColor: 'rgba(52, 152, 219, 0.7)'
          },
          {
            label: 'Cajas Saldos',
            data: saldos,
            backgroundColor: 'rgba(44, 62, 80,0.7)'
          },
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: 'CAJAS POR UBICACIÓN',
          position: 'top',
          fontSize: 18,
          fontColor: '#3498DB',
          padding:25
        },
        scales: {
          xAxes: [{ stacked: true }],
          yAxes: [{ stacked: true }]
        }
      }
    });*/
  }

  drawGraphPalletsUbicacion(labels,pallets){
    this.canvas = document.getElementById('graficopalletsxubicacion');
    //console.log("getContext", this.canvas.getContext('2d'));
    this.ctx = this.canvas.getContext('2d');

    const chart: Chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: "Cantidad de pallets",
            data: pallets,
            backgroundColor: "rgba(52, 152, 219, 0.7)"
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: 'PALLETS POR UBICACIÓN',
          position: 'top',
          fontSize: 18,
          fontColor: '#3498DB',
          padding:25
        }
      }
    });

    this._loaddata.loadChange(0);
    this.alert = "Carga correcta.";
    this.isopen =true;
    this.onClosedAutomatic();
  }

  drawGraphSaldosUbicacion(labels,cajas){
    this.canvas = document.getElementById('graficosaldosxubicacion');
    this.ctx = this.canvas.getContext('2d');

    const chart: Chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Cajas Saldos',
            data: cajas,
            backgroundColor: 'rgba(52, 152, 219, 0.7)'
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: 'SALDOS POR UBICACIÓN',
          position: 'top',
          fontSize: 18,
          fontColor: '#3498DB',
          padding:25
        }
      }
    });
  }

  drawGraphPesosUbicacion(labels,cajas){
    this.canvas = document.getElementById('graficopesoxubicacion');
    this.ctx = this.canvas.getContext('2d');

    const chart: Chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Peso Cajas',
            data: cajas,
            backgroundColor: 'rgba(52, 152, 219, 0.7)'
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: 'PESOS TOTALES POR UBICACIÓN',
          position: 'top',
          fontSize: 18,
          fontColor: '#3498DB',
          padding:25
        }
      }
    });
  }

  drawGraphPesosCompletosUbicacion(labels,cajas){
    this.canvas = document.getElementById('graficopesoscompletasxubicacion');
    this.ctx = this.canvas.getContext('2d');

    const chart: Chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Peso Cajas Completas',
            data: cajas,
            backgroundColor: 'rgba(52, 152, 219, 0.7)'
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: 'PESOS CAJAS COMPLETAS POR UBICACIÓN',
          position: 'top',
          fontSize: 18,
          fontColor: '#3498DB',
          padding:25
        }
      }
    });
  }

  drawGraphPesosSaldosUbicacion(labels,cajas){
    this.canvas = document.getElementById('graficopesossaldosxubicacion');
    this.ctx = this.canvas.getContext('2d');

    const chart: Chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Cajas Saldo',
            data: cajas,
            backgroundColor: 'rgba(52, 152, 219, 0.7)'
          }
        ]
      },
      options: {
        legend: { display: false },
        title: {
          display: true,
          text: 'PESOS SALDOS POR UBICACIÓN',
          position: 'top',
          fontSize: 18,
          fontColor: '#3498DB',
          padding:25
        }
      }
    });
  }

  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(0);
    this.isopen =true;
  }

  /**
  * Cierra el mensaje de alerta.
  */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 5 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 5000);

  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/panelcontrol/panelcontrol.component.ts